import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../components/Converter.js";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit.jsx";
import { ImperialUnits, MetricUnits } from "../../../../components/Math/Units/AllUnits.jsx";
import Foot from "../../../../components/Math/Units/Imperial/Foot.jsx";
import Metre from "../../../../components/Math/Units/Metric/Metre.jsx";
import { RowBody } from "../../../../components/RowValue/RowBody.jsx";
import { decimalSeparator, thousandSeparator } from "../../../../i18n.js";
import {
  selectExtensionIntoFoundation,
  setExtensionIntoFoundation,
} from "../../../../store/slices/fhwaSlice.js";
import { selectIsImperial, selectIsMetric } from "../../../../store/slices/settingsSlice.js";

function ExtensionIntoFoundation() {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");

  const extensionIntoFoundation = useSelector(selectExtensionIntoFoundation);

  const isImperial = useSelector(selectIsImperial);
  const isMetric = useSelector(selectIsMetric);

  let unitType = isMetric ? MetricUnits.Metre : isImperial ? ImperialUnits.Foot : null;

  return (
    <RowBody
      titleValue={<p>{t("aashto.ausser.Extension into foundation")}</p>}
      inputValue={
        <span className="input-change">
          <NumberFormat
            className={getClassName(extensionIntoFoundation.current)}
            decimalSeparator={decimalSeparator()}
            thousandSeparator={thousandSeparator()}
            displayType="input"
            type="text"
            allowNegative={true}
            value={extensionIntoFoundation?.current ?? 0}
            onValueChange={(values) => {
              dispatch(
                setExtensionIntoFoundation({
                  value: values?.floatValue ?? 0,
                  unit: unitType,
                })
              );
            }}
          />
        </span>
      }
      unitValue={<ConvertUnit Metric={<Metre />} Imperial={<Foot />} />}
    />
  );
}

export default ExtensionIntoFoundation;
